import { render, staticRenderFns } from "./rowData.vue?vue&type=template&id=d61d37a8&scoped=true"
import script from "./rowData.vue?vue&type=script&lang=js"
export * from "./rowData.vue?vue&type=script&lang=js"
import style0 from "./rowData.vue?vue&type=style&index=0&id=d61d37a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61d37a8",
  null
  
)

export default component.exports